import { IS_UGC_FLOW } from 'config/envVariable';

import promo from './modules/promo';
import promoTasks from './modules/promoTasks';
import gameFormBased from './modules/gameFormBased';
import settingPromo from './modules/settingPromo';
import settingPointSystems from './modules/settingPointSystems';
import settingStyle from './modules/settingStyle';
import settingGame from './modules/settingGame';
import settingTheme from './modules/settingTheme';
import settingGameStyle from './modules/settingGameStyle';
import settingEntryValue from './modules/settingEntryValue';
import settingMGMReferral from './modules/settingMGMReferral';
import settingPlan from './modules/settingPlan';
import signUpForm from './modules/signUpForm';
import awardeeForm from './modules/awardeeForm';
import zines from './modules/zines';
import lotteryAdmin from './modules/lotteryAdmin';
import lotteryInstant from './modules/lotteryInstant';
import lotteryParticipant from './modules/lotteryParticipant';
import lotteryTasks from './modules/lotteryTasks';
import lotteryPrizes from './modules/lotteryPrizes';
import flags from './modules/flags';
import flagsUgc from './modules/flagsUgc';
import ugcCollections from './modules/ugcCollections';
import ugcMediaOfMember from './modules/ugcMediaOfMember';
import appState from './modules/appState';
import promoState from './modules/promoState';
import userEntryState from './modules/userEntryState';
import userGameResultRecords from './modules/userGameResultRecords';
import userLoginState from './modules/userLoginState';
import userWinnerPrize from './modules/userWinnerPrize';
import purePrizeState from './modules/purePrizeState';
import systemErrorDialog from './modules/systemErrorDialog';
import partner from './modules/partner';
import sponsor from './modules/sponsor';
import pointSystem from './modules/pointSystem';
import mgmRelation from './modules/mgmRelation';
import mgmReferral from './modules/mgmReferral';
import aiExtensions from './modules/aiExtensions';
import settingAIExtensions from './modules/settingAIExtensions';

export const staticReducers = {
    partner,
    sponsor,
    promo,
    promoTasks,
    gameFormBased,
    settingPromo,
    settingPointSystems,
    settingStyle,
    settingGame,
    settingGameStyle,
    settingMGMReferral,
    settingEntryValue,
    settingTheme,
    settingPlan,
    settingAIExtensions,
    signUpForm,
    awardeeForm,
    zines,
    lotteryAdmin,
    lotteryInstant,
    lotteryParticipant,
    lotteryTasks,
    lotteryPrizes,
    appState,
    promoState,
    userLoginState,
    userEntryState,
    userGameResultRecords,
    userWinnerPrize,
    purePrizeState,
    systemErrorDialog,
    flags,
    pointSystem,
    mgmRelation,
    mgmReferral,
    aiExtensions,
    ...(IS_UGC_FLOW ? { flagsUgc, ugcCollections, ugcMediaOfMember } : {})
};
